<template>
  <div class="flex-column">
    <div v-if="menuItems">
      <Menu :model="menuItems" id="admin-menu" />
    </div>
  </div>
</template>
<script setup lang="ts">
import type { DynamicsType } from '~/server/types/dynamics';
import { reduce } from 'lodash-es';

const settings = useGeneralStore();
const tenant=useTenant();
const {currentTenant, currentTenantMenuItems} = useAdminTenant(); 
const menuItems = ref<any[]>([]);

const formatMenuItems = () => {
    let tmpMenuItems:any[] = [
      {
        label: 'Generali',
        items: [
          {
            label: 'Utenti',
            icon: 'pi pi-users',
            command: () => navigateTo(`/admin/users`),
          },
          {
            label: 'Organizzazioni',
            icon: 'pi pi-sitemap',
            command: () => navigateTo(`/admin/tenants`),
          }
        ]
      },
    ];
    if(currentTenantMenuItems.value?.length) {
      tmpMenuItems.push({
        label: 'Organizzazione',
        items: reduce(currentTenantMenuItems.value, (f:any[],v:any) => {
          if(['ADMIN','STANDARD'].includes(v.liv)){
            f.push({
                label: v.name,
                icon: `pi pi-${v.icon}`,
                command: () => navigateTo(`/admin/${v._id}/${v.table}`),
              });
          }
          return f;
        },[])
      });
    }
    menuItems.value = tmpMenuItems;
  };

  watch(currentTenantMenuItems, () => {
    log('watch');
    formatMenuItems();
  },{immediate: true});
</script>
<style lang="scss" scoped>
@use '@/assets/css/style.scss';

#admin-menu.p-menu{
  background: transparent;
  border: none;
  color: var(--primary-color-text);
  .p-submenu-header, .p-menuitem-text, .p-menuitem-icon{
    background: transparent;
    color: var(--primary-color-text);
  }
}
.menu-link.router-link-active {
  position: relative;
  &>div {
    background: var(--surface-100);
    color: var(--primary-color-text);

    &:before,
    &:after {
      content: '';
      top: 0;
      left: 0;
      height: 10px;
      width: 100%;
      background-color: var(--primary-color);
    }

    &:before {
      @include style.BorderRadius($tl: 0, $tr: 0, $br: 10px, $bl: 0, $all: 0);
    }
    &:after {
      top: auto;
      bottom: 0;
      @include style.BorderRadius($tl: 0, $tr: 10px, $br: 0, $bl: 0, $all: 0);
    }
  }
}
</style>